// @core/api/endpoints/secret/revoke_lease.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RevokeLeaseRequest,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Revoke lease
 * Immediately revokes a lease and cleans up the associated credential (e.g., drops the database user). This operation is irreversible.
 */
export async function RevokeLease(
  lease_id: string,
  data: RevokeLeaseRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/leases/:lease_id/revoke`;
  requestPath = requestPath.replace(':lease_id', encodeURIComponent(lease_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
